import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export const HeroSection = () => {
  const scrollToNext = () => {
    const element = document.getElementById("why");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="relative w-full h-[95dvh] overflow-hidden"
    >
      {/* Full-screen Video Background */}
      <div className="absolute inset-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          poster="https://images.pexels.com/videos/4980183/pexels-photo-4980183.jpeg?auto=compress&cs=tinysrgb&w=1920"
        >
          {/* Tree leaves with sunlight filtering through - bright and warm */}
          <source
            src="https://videos.pexels.com/video-files/4980183/4980183-uhd_2560_1440_25fps.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        
        {/* Dark overlay for text readability */}
        <div 
          className="absolute inset-0 bg-black/35 bg-gradient-to-b from-black/40 via-black/20 to-[#F5ECD7]/30"
        />
      </div>

      {/* Center intro text */}
      <div className="absolute inset-0 flex items-center justify-center z-10 px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.3 }}
          className="text-center max-w-2xl"
        >
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.15] mb-4">
            Pull up a chair. <span className="italic">Let's talk.</span>
          </h1>
          <p className="font-sans text-base sm:text-lg text-white/70 leading-relaxed max-w-lg mx-auto">
            Not therapy. Not networking. Just two humans and a genuine conversation.
          </p>
        </motion.div>
      </div>

      {/* Scroll indicator - bottom center */}
      <motion.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        onClick={scrollToNext}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 text-white/70 hover:text-white transition-colors z-10"
        aria-label="Scroll down"
      >
        <span className="font-sans text-xs tracking-[0.3em] uppercase">
          Scroll
        </span>
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        >
          <ChevronDown className="w-5 h-5" />
        </motion.div>
      </motion.button>
    </section>
  );
};
